// extracted by mini-css-extract-plugin
export var wrapper = "SashBanner-module--wrapper--5ao8n";